import { PackageCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import { NoticeShell } from "./NoticeShell";

export function DocReturnNotice() {
  const [d, setD] = useState<any>(null);
  useEffect(() => { api.get("/doc-returns/summary").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d || !d.pending) return null;
  const to = "/pengembalian-dokumen";
  return (
    <NoticeShell id="doc-return-notice" tone="sky" to={to} icon={<PackageCheck className="h-5 w-5" />}
      title={<p>Pengembalian dokumen menunggu · {d.pending} siswa lunas</p>}
      action={<Link to={to} className="font-semibold text-sky-700 dark:text-sky-300 hover:underline" data-testid="doc-return-notice-link">Proses sekarang →</Link>}>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {d.items.map((it: any) => (
          <span key={it.loan_id} className="rounded-full bg-white/70 dark:bg-white/10 border border-sky-200 dark:border-sky-800 px-2.5 py-0.5 text-xs" data-testid={`doc-return-notice-item-${it.internal_id}`}>
            <span className="font-semibold">{it.name}</span> <span className="text-muted-foreground num">· {it.internal_id}{it.lunas_at ? ` · lunas ${fmtDate(it.lunas_at.slice(0, 10))}` : ""}</span>
          </span>
        ))}
        {d.pending > d.items.length && <span className="text-xs text-muted-foreground self-center">+{d.pending - d.items.length} lainnya</span>}
      </div>
    </NoticeShell>
  );
}
